import React, { useState } from 'react';
import { Importer, ImporterField } from 'react-csv-importer';
import { submitDataSrikandiRemoveTag } from '../../../../API';

interface Props {
  date: Date;
}

export interface RemovetagRow {
  email: string;
  shopify_id: string;
}

const CSVImporterRemoveShopifyTag
 = () => {

  const [rows, setRows] = useState<RemovetagRow[]>([]);

  const handleDataRows = (r: any[]) => {
    const sanitised: RemovetagRow[] = r
      .map((e) => ({
        email: e.email,
        shopify_id: e.shopify_id,
      }))
    setRows((rows) => rows.concat(sanitised));
  };

  const handleComplete = async () => {
    // run importer

    console.log("rows",rows)
    await submitDataSrikandiRemoveTag(rows);
  };

  return (
    <Importer
      dataHandler={(rows, { startIndex }) => {
        handleDataRows(rows);
      }}
      defaultNoHeader={false} // optional, keeps "data has headers" checkbox off by default
      restartable // optional, lets user choose to upload another file when import is complete
      onComplete={handleComplete}
      /*onStart={({ file, preview, fields, columnFields }) => {
        // optional, invoked when user has mapped columns and started import
        prepMyAppForIncomingData();
      }}

      onClose={({ file, preview, fields, columnFields }) => {
        // optional, if this is specified the user will see a "Finish" button after import is done,
        // which will call this when clicked
        goToMyAppNextPage();
      }}*/

      // CSV options passed directly to PapaParse if specified:
      // delimiter={...}
      // newline={...}
      // quoteChar={...}
      // escapeChar={...}
      // comments={...}
      // skipEmptyLines={...}
      // delimitersToGuess={...}
      // chunkSize={...} // defaults to 10000
      // encoding={...} // defaults to utf-8, see FileReader API
    >
      <ImporterField name="email" label="Email" />
      <ImporterField name="shopify_id" label="Shopify ID" />
    </Importer>
  );
};

export default CSVImporterRemoveShopifyTag
;
